import React, { useContext } from 'react'

interface IOfferSmeContext {
  onCompareClick: Function
}

interface IOfferSmeProvider {
  onCompareClick: Function
  children?: React.ReactNode
}

const defaultState = {
  onCompareClick: () => { }
}

const OfferSmeContext = React.createContext<IOfferSmeContext>(defaultState)

export const OfferSmeProvider = ({ onCompareClick, children }: IOfferSmeProvider) => {
  return (
    <OfferSmeContext.Provider
      value={{
        onCompareClick,
      }}
    >
      {children && children}
    </OfferSmeContext.Provider>
  )
}

export const useOfferSme = () => {
  const context = useContext(OfferSmeContext)

  if (context === undefined || Object.keys(context).length == 0) {
    throw new Error('useOfferSme must be used within a OfferSmeProvider!')
  }

  return context
}
